import { isTruthy } from "@/utils/guards";

export const formatAddress = (address: {
    streetNumber?: string | null;
    streetName?: string | null;
    locality?: string | null;
    zipCode?: string | null;
    country?: string | null;
}) => {
    // format as "streetNumber streetName, locality, zipCode, country"
    // without commas if the value is empty
    const number = isTruthy(address.streetNumber) ? address.streetNumber : "";
    const name = isTruthy(address.streetName) ? ` ${address.streetName}` : "";
    const locality = isTruthy(address.locality) ? `, ${address.locality}` : "";
    const zip = isTruthy(address.zipCode) ? `, ${address.zipCode}` : "";
    const country = isTruthy(address.country) ? `, ${address.country}` : "";
    return `${number}${name}${locality}${zip}${country}`;
};

export const creationTestIds = {
    dealInfoFormTitle: "DealInfoForm-title",
    nameWarningMessage: "DealInfoForm-nameWarningMessage",
    navbarNextButton: "Navbar-nextButton",
    navbarBackButton: "Navbar-backButton",
    subNavbarNextButton: "SubNavbar-nextButton",
    subNavbarBackButton: "SubNavbar-backButton",
    propertyListTitle: "PropertyList-title",
    propertyListCreatePropertyButton: "PropertyList-createPropertyButton",
    propertyListCount: "PropertyList-count",
    propertyListEditProperty: (index: number) =>
        `PropertyList-editProperty-${index}`,
    propertyListDeleteProperty: (index: number) =>
        `PropertyList-deleteProperty-${index}`,
    propertyListRemovePropertyFromList: (index: number) =>
        `PropertyList-removePropertyFromList-${index}`,
    propertyAddressErrorMessage:
        "CreatePropertyAddressForm-propertyAddressErrorMessage",
    propertyFormEditAddressButton: "PropertyForm-editAddressButton",
    propertyFormEditDetailsButton: "PropertyForm-editDetailsButton",
    propertyFormConfirmAddressButton: "PropertyForm-confirmAddressButton",
    propertyFormConfirmDetailsButton: "PropertyForm-confirmDetailsButton",
};
